// Section 17: priority group 'Other workers'. Members are listed in sorted id order; the rationing
// phase ranks groups by the policy's order and breaks ties by lowest strength first.
import { definePriorityGroup } from '../../core/registry';
import { peopleSorted } from '../../core/queries';
import type { Config } from '../../config';

export function otherWorkers(_config: Config) {
  const NAMED_JOBS = new Set([
    'farmer',
    'forager',
    'hunter',
    'water-carrier',
    'builder',
    'toolmaker',
    'healer',
    'teacher',
    'guard',
  ]);

  return definePriorityGroup({
    id: 'other-workers',
    label: 'Other workers',
    section: 'S17',
    members: (ctx) =>
      peopleSorted(ctx.state)
        .filter((p) => p.job !== 'rest' && !NAMED_JOBS.has(p.job))
        .map((p) => p.id),
  });
}
